import React from "react"
import { ContextProvider } from "./src/context/dataContext"
import "./src/css/index.css"
import { QueryClientProvider } from "./src/utils/react-query-config"
export const wrapRootElement = ({ element }) => (
  <ContextProvider><QueryClientProvider>{element}</QueryClientProvider></ContextProvider>
)